/**
 * Logged-in OTP customers → mirror cart to spin-event draft orders (same as spin wheel).
 */
(function () {
  'use strict';

  const DEBOUNCE_MS = 400;
  let syncTimer = null;
  let syncInFlight = false;

  function webhookUrl() {
    const popup = document.getElementById('vrv-spin-popup');
    const fromPopup = popup && popup.dataset ? popup.dataset.vrvSwWebhook : '';
    if (fromPopup) return String(fromPopup).trim();
    const cfg = window.vrvUserSyncConfig || {};
    if (cfg.spinWebhookUrl) return String(cfg.spinWebhookUrl).trim();
    return '';
  }

  function shopDomain() {
    const popup = document.getElementById('vrv-spin-popup');
    const fromPopup = popup && popup.dataset ? popup.dataset.vrvSwShop : '';
    if (fromPopup) return String(fromPopup).trim();
    return window.shopUrl ? String(window.shopUrl).replace(/^https?:\/\//, '') : '';
  }

  function isLoggedIn() {
    return (
      document.body.getAttribute('data-vrv-customer-logged-in') === '1' ||
      document.body.classList.contains('customer-logged-in')
    );
  }

  function customerPhoneE164() {
    const raw = String(document.body.getAttribute('data-vrv-customer-phone') || '').trim();
    let digits = raw.replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2);
    if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
    if (digits.length === 10) return '+91' + digits;

    try {
      const stored = String(localStorage.getItem('vrvCheckoutPhone') || '').trim();
      digits = stored.replace(/\D/g, '');
      if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2);
      if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
      if (digits.length === 10) return '+91' + digits;
    } catch (_) {
      /* ignore */
    }
    return '';
  }

  function summariseCart(cart) {
    if (!cart) return null;
    return {
      token: cart.token,
      item_count: cart.item_count,
      total_price: cart.total_price,
      currency: cart.currency,
      items: (cart.items || []).map(function (it) {
        return {
          variant_id: it.variant_id,
          product_id: it.product_id,
          title: it.product_title || it.title,
          variant: it.variant_title || null,
          quantity: it.quantity,
          price: it.price,
          sku: it.sku || null,
          url: it.url,
          image: it.image || (it.featured_image && it.featured_image.url) || null,
          source: 'cart',
        };
      }),
    };
  }

  function postSpinEvent(eventName, phone, extra) {
    const url = webhookUrl();
    if (!url || !phone) return;

    const payload = {
      event: eventName,
      shop: shopDomain(),
      phone: phone,
      phone10: phone.replace(/^\+91/, ''),
      source: 'otp_logged_in',
      url: window.location.href,
      referrer: document.referrer || null,
      at: new Date().toISOString(),
    };

    if (extra) {
      Object.keys(extra).forEach(function (key) {
        payload[key] = extra[key];
      });
    }

    const body = JSON.stringify(payload);
    const blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
    if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) return;

    fetch(url, {
      method: 'POST',
      credentials: 'omit',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: body,
    }).catch(function () {});
  }

  async function syncCartToDraft(reason) {
    if (!isLoggedIn() || syncInFlight) return;
    const phone = customerPhoneE164();
    if (!phone) return;

    syncInFlight = true;
    try {
      const res = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return;
      const cart = await res.json();
      postSpinEvent(reason || 'cart_mutation', phone, {
        cart: summariseCart(cart),
        cartToken: cart && cart.token,
      });
    } catch (_) {
      /* ignore */
    } finally {
      syncInFlight = false;
    }
  }

  function scheduleSync(reason) {
    if (!isLoggedIn() || !customerPhoneE164()) return;
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      syncCartToDraft(reason);
    }, DEBOUNCE_MS);
  }

  function installFetchHook() {
    if (window.__vrvCartDraftSyncHooked || window.__vrvSpinFetchHooked) {
      return;
    }
    window.__vrvCartDraftSyncHooked = true;
    const origFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isCartMutation =
        /\/cart\/(add|change|update|clear)\.js/.test(url) &&
        init &&
        String(init.method || 'GET').toUpperCase() === 'POST';

      const result = origFetch(input, init);
      if (!isCartMutation) return result;

      return result.then(function (res) {
        setTimeout(function () {
          scheduleSync('cart_mutation');
        }, 60);
        return res;
      });
    };
  }

  function boot() {
    if (!isLoggedIn() || !customerPhoneE164()) return;
    installFetchHook();
    document.addEventListener('cart:updated', function (event) {
      // Drawer re-renders don't change the cart; skip the /cart.js + worker POST.
      var source = event && event.detail && event.detail.source;
      if (source === 'refreshDrawer' || source === 'vrv-partial-refresh') return;
      scheduleSync('cart_mutation');
    });
    scheduleSync('page_view');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleSync('page_view');
  });
})();
